import type { CSSProperties, RefObject } from 'react';
import { PANEL_GAP_PX } from './LiksDropdown.types';

export function getDropdownPanelStyle(
  triggerRef: RefObject<HTMLButtonElement | null>,
  panelRef: RefObject<HTMLDivElement | null>,
): CSSProperties | null {
  if (!triggerRef.current) {
    return null;
  }

  const rect = triggerRef.current.getBoundingClientRect();
  const panelHeight = panelRef.current?.offsetHeight ?? 0;
  const panelWidth = Math.max(rect.width, panelRef.current?.offsetWidth ?? 0);
  const spaceBelow = window.innerHeight - rect.bottom - PANEL_GAP_PX;
  const openUpward =
    panelHeight > 0 &&
    spaceBelow < panelHeight &&
    rect.top > panelHeight + PANEL_GAP_PX;
  const left = Math.min(
    rect.left,
    Math.max(PANEL_GAP_PX, window.innerWidth - panelWidth - PANEL_GAP_PX),
  );

  return {
    position: 'fixed',
    top: openUpward ? undefined : rect.bottom + PANEL_GAP_PX,
    bottom: openUpward
      ? window.innerHeight - rect.top + PANEL_GAP_PX
      : undefined,
    left,
    minWidth: rect.width,
    width: 'max-content',
    maxWidth: `calc(100vw - ${PANEL_GAP_PX * 2}px)`,
    zIndex: 'var(--z-popover)',
  };
}

export function scrollDropdownActiveOptionIntoPanel(
  optionsListRef: RefObject<HTMLDivElement | null>,
  panelRef: RefObject<HTMLDivElement | null>,
  option: HTMLDivElement | null | undefined,
): void {
  const scrollParent = optionsListRef.current ?? panelRef.current;
  if (!scrollParent || !option) {
    return;
  }

  const optionTop = option.offsetTop;
  const optionBottom = optionTop + option.offsetHeight;
  const visibleTop = scrollParent.scrollTop;
  const visibleBottom = visibleTop + scrollParent.clientHeight;

  if (optionTop < visibleTop) {
    scrollParent.scrollTop = optionTop;
    return;
  }

  if (optionBottom > visibleBottom) {
    scrollParent.scrollTop = optionBottom - scrollParent.clientHeight;
  }
}
